export default (range) => {
  return [...Array(range).keys()];
};
